<mat-chip>
    <mat-icon
        *ngIf="disableRemove"
        class="remove_filter_icon"
        matChipRemove
        (click)="remove()"
        >cancel
    </mat-icon>
    <div class="content-wrapper" (click)="directionChange()">
        <div class="normal_text">
            {{ sort?.name }}
        </div>

        <div class="direction-wrapper">
            <mat-icon
                [ngClass]="{
                    'sort-descending':
                        sort?.direction == sortDirectionEnum.Descending
                }"
                class="toolbar_icon_color sort-direction-icon"
                >north</mat-icon
            >
            <mat-icon class="toolbar_icon_color sort-icon">sort</mat-icon>
        </div>
    </div>
</mat-chip>
